import { connect } from 'react-redux';
import { ITabActivityHOCProps } from './types';
import { ActivityActions } from '../../components/ActivityActions/ActivityActions';
import { IActivityActionsEvents, IActivityActionsFields } from '../../components/ActivityActions/types';
import { onUndo } from './events/onUndo';
import { IApplicationState } from '../../../../../../../../types/types';
import { getActivities } from '../../../../../../../../store/activities/selectors/getActivities';
import {
    getBoardPermissionsIsReadonly
} from '../../../../../../main/kanbanView/selectors/getBoardPermissionsIsReadonly';

const mapStateToProps = (
    state: IApplicationState,
    { activity }: ITabActivityHOCProps
): IActivityActionsFields => {
    let isShow = !!activity;
    if (!isShow) return { isShow };

    const {
        modelType,
        propertyName,
        id,
        dashboardId: boardId,
    } = activity;
    const activities = getActivities(state);
    const isReadonly = getBoardPermissionsIsReadonly(state, boardId);
    if (isReadonly) {
        isShow = false;
    } else {
        const lastActivity = activities.find(activity => {
            return activity.modelType === modelType && activity.propertyName === propertyName;
        });
        if (lastActivity && lastActivity.id !== id) {
            isShow = false;
        }
    }
    return {
        activityId: activity.id,
        isShow,
    };
}

const mapDispatchToProps = (
    dispatch: any,
    { activity }: ITabActivityHOCProps
): IActivityActionsEvents => {
    return {
        onUndo: () => dispatch(onUndo(activity)),
    };
}

export const ActivityActionsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivityActions);

ActivityActionsHOC.displayName = 'ActivityUndoHOC';
